export default __webpack_public_path__ + "static/media/care-plan-assigned.4b18132d.png";